module.exports = __webpack_public_path__ + "img/dy.82fa2b8c.png";